import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface Token {
  TokenId: string;
  Account: string;
  AppName: string;
  TokenName: string;
  TokenType: string;
  AccessToken: string;
  ExpiresOn: Date;
  Scope: string;
}

@Injectable({
  providedIn: 'root'
})
export class ConfigVaultService {
  private readonly jwtConfig = environment.jwtConfig;

  constructor(
    private http: HttpClient) { }

  getJWT(): Observable<string> {
    const params = new HttpParams()
      .set('issuerIdentifier', this.jwtConfig.issuerIdentifier)
      .set('checkNestedAdGroups', this.jwtConfig.checkNestedAdGroups);

    return this.http.get<string>(
      `${environment.services.configVault}/Jwt/${this.jwtConfig.appName}`,
      {
        withCredentials: true,
        params: params
      }
    );
  }

  getAccessToken(): Observable<Token> {
    return this.http.get<Token>(
      `${environment.services.configVault}/Token/${this.jwtConfig.appName}?tokenname=NewAccessToken`,
      {
        withCredentials: true
      }
    )
  }
}
